import { useContext } from 'react';

import { Shimmer } from '@components';

import CloseImage from '@assets/svg/close-btn.svg';

import { CustomStatusContext } from '../../CustomStatus.query';

import {
  Close,
  Header,
  Line,
  Form,
  Divider,
} from './DeleteEquipmentStatus.styles';

export const DeleteEquipmentStatusLoading = () => {
  const { openDelete } = useContext(CustomStatusContext);

  return (
    <div>
      <Header>
        <Shimmer
          style={{ height: 30, width: 200, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Close onClick={() => openDelete.set(false)}>
          <img src={CloseImage} alt="close" />
        </Close>
      </Header>
      <Divider />
      <Form>
        <Shimmer
          style={{ height: 24, width: '100%', borderRadius: 4, marginTop: 24 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 24, width: '80%', borderRadius: 4, marginTop: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Line>
          <Shimmer
            style={{ height: 36, width: 77, borderRadius: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </Line>
      </Form>
    </div>
  );
};
